/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsDiscountsOverviewCtrl
 */
angular.module('mercury.modules.reports.discounts')
.controller('ReportsDiscountsOverviewCtrl', ["$scope", "$q", "PosDiscounts", "PosSurcharges", "PosVoids", "ReportSales", "reporttime", "title", "userinfo", function($scope, $q, PosDiscounts, PosSurcharges, PosVoids, ReportSales, reporttime, title, userinfo) {
  title.set('Fraud & Discounting Overview');

  $scope.surchargeEnabled = userinfo.companyPos() == 'Cloudpos';

  var promises = {
    sales: ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval()),
    discountTypes: PosDiscounts.get(reporttime.start(), reporttime.end()),
    voids: PosVoids.getByReason(reporttime.start(), reporttime.end())
  };

  if ($scope.surchargeEnabled) {
    promises.surchargeTypes = PosSurcharges.get(reporttime.start(), reporttime.end());
  }

  $scope.loading = $q.all(promises);

  $scope.loading.then(function(results) {
    $scope.sales = results.sales;
    $scope.discountTypes = results.discountTypes;
    $scope.surchargeTypes = results.surchargeTypes ? results.surchargeTypes : [];
    $scope.voids = results.voids;
  });

  // Column definition for the main column graph
  $scope.discountsGraphColums = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Discounts', type: 'number', key: 'discounts', filter: 'currency'},
    {label: 'Surcharges', type: 'number', key: 'surcharges', filter: 'currency'}
  ];

  // Column definition for the 'Item Categories' graph
  $scope.discountTypesColumns = [
    {label: 'Discount Types', type: 'string', key: 'discountType'},
    {label: 'Amount', type: 'number', key: 'discountsAmount', filter: 'currency'}
  ];

  $scope.surchargeTypesColumns = [
    {label: 'Surcharge Types', type: 'string', key: 'surchargeType'},
    {label: 'Amount', type: 'number', key: 'surchargesAmount', filter: 'currency'}
  ];
}]);
